import { useCallback } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";
import { ElementId } from "../../constants/enums";
import { wpLocalMuteControlPropsAtom } from "../../recoil/atoms/local-mute";
import { playerPropsSelector } from "../../recoil/atoms/player";
import { checkIsModNotPresentId } from "../../util";
import { waitForElm } from "../../util/waitForElm";
import useMeetingClient from "../useMeetingClient";
import { useWatchParty } from "../useWatchParty";

const useWpVideoController = () => {

  const meetingClient = useMeetingClient()
  const setPlayerProps = useSetRecoilState(playerPropsSelector)
  const { isHost, watchPartyHostId } = useWatchParty()
  const [wpLocalMuteControlProps, setWpLocalMuteControlProps] =
      useRecoilState(wpLocalMuteControlPropsAtom)

  const getVideoElement = useCallback(async () => {
   return (await waitForElm(
      ElementId.WATCH_PARTY_VIDEO
    )) as HTMLVideoElement
    
  }, [])

  const muteAudio = useCallback(async () => {
    setPlayerProps({ muted: true })
    const videoElement = await getVideoElement()
    videoElement.muted = true

    if(!isHost) {
      // Stop server mute control
      meetingClient?.rtc?.toggleControlMute(false)
    }

  }, [ isHost ])

  const unmuteAudio = useCallback(async () => {
    // if host, unmute only if watch is unmuted
    if(wpLocalMuteControlProps.enabled && wpLocalMuteControlProps.value) {
      return
    } 
    else if (!checkIsModNotPresentId(watchPartyHostId) && !isHost) {
      // if not host user, give host user mute control
      meetingClient?.rtc?.toggleControlMute(true)
      return // not need to unmute video it will done in next wp message
    }

    setPlayerProps({ muted: false })
    const videoElement = await getVideoElement()
    videoElement.muted = false
    // meetingClient?.rtc?.toggleWpLocalMuteControl({
    //   enabled: false,
    //   value: false
    // })
    if(!isHost) {
      meetingClient?.rtc?.toggleControlMute(true)
    }

  }, [ 
    isHost,
    watchPartyHostId,
    wpLocalMuteControlProps.value]) 

  return {
    muteAudio,
    unmuteAudio
  }
}

export default useWpVideoController;
